import { render, staticRenderFns } from "./ImageTemplate.vue?vue&type=template&id=1e132279&scoped=true&"
import script from "./ImageTemplate.vue?vue&type=script&lang=js&"
export * from "./ImageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ImageTemplate.vue?vue&type=style&index=0&id=1e132279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e132279",
  null
  
)

export default component.exports